import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import StatusStamp from '../components/StatusStamp';
import Pagination from '../components/Pagination';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadDashboard(); }, [page, search]);

  async function loadDashboard() {
    setLoading(true);
    try {
      const { data: result } = await api.get('/dashboard', { params: { page, search: search || undefined } });
      setData(result);
    } catch {}
    setLoading(false);
  }

  if (loading && !data) return <div className="flex items-center justify-center py-12 text-ink-muted">Carregando...</div>;
  if (!data) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold tracking-tight">Dashboard</h1>
          <p className="text-sm text-ink-muted mt-1">Visao geral do seu trabalho</p>
        </div>
      </div>

      {/* Metrics */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-surface-100 border rounded-md p-4">
          <div className="text-2xs font-semibold text-ink-muted uppercase tracking-wide">Revisões Pendentes</div>
          <div className="text-2xl font-bold font-mono tabular-nums mt-1 text-status-review">{data.pending_reviews}</div>
        </div>
        <div className="bg-surface-100 border rounded-md p-4">
          <div className="text-2xs font-semibold text-ink-muted uppercase tracking-wide">Aprovações Pendentes</div>
          <div className="text-2xl font-bold font-mono tabular-nums mt-1 text-status-approval">{data.pending_approvals}</div>
        </div>
        <div className="bg-surface-100 border rounded-md p-4">
          <div className="text-2xs font-semibold text-ink-muted uppercase tracking-wide">Notificações</div>
          <div className="text-2xl font-bold font-mono tabular-nums mt-1 text-status-rejected">{data.unread_notifications}</div>
        </div>
      </div>

      {/* My Documents */}
      <div className="bg-surface-100 border rounded-md p-4">
        <div className="flex items-center justify-between mb-4 pb-3 border-b border-subtle">
          <h3 className="text-base font-semibold">Meus Documentos</h3>
        </div>

        <div className="flex gap-3 mb-4">
          <input type="text" className="form-input flex-1" placeholder="Buscar por nome, código ou descrição..."
            value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
        </div>

        {data.documents.data.length === 0 ? (
          <div className="text-center py-12 text-ink-muted">
            <h3 className="text-lg mb-2">Nenhum documento encontrado</h3>
            <p>Você não participa de nenhum documento no momento.</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b">
                    <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Código</th>
                    <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Nome</th>
                    <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Versão</th>
                    <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.documents.data.map((doc) => (
                    <tr key={doc.id} className="border-b border-subtle hover:bg-surface-inset">
                      <td className="px-3 py-3"><Link to={`/documents/${doc.id}`} className="doc-code">{doc.code}</Link></td>
                      <td className="px-3 py-3">
                        <Link to={`/documents/${doc.id}`} className="text-ink-primary no-underline font-medium hover:text-brand">
                          {doc.name}
                        </Link>
                      </td>
                      <td className="px-3 py-3"><span className="version-label">{doc.version_number}.{doc.sub_version}</span></td>
                      <td className="px-3 py-3"><StatusStamp status={doc.current_status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination page={data.documents.page} total={data.documents.total}
              limit={data.documents.limit} onPageChange={setPage} />
          </>
        )}
      </div>
    </div>
  );
}
